import { isMobileResult } from './isMobile'

export default function isIpad() {
    return isMobileResult.apple.tablet
}
